import React, { useState } from 'react';
import { LoadScript } from '@react-google-maps/api';
import { Box } from '@chakra-ui/react';

// You'll need to add your Google Maps API key here
// Get it from: https://console.cloud.google.com/google/maps-apis/
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'YOUR_API_KEY_HERE';

const libraries = ['places'];

export const GoogleMapsLoader = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = (error) => {
    setLoadError(error);
    console.error('Google Maps loading error:', error);
  };

  if (loadError) {
    return (
      <Box>
        {children}
      </Box>
    );
  }

  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={libraries}
      onLoad={handleLoad}
      onError={handleError}
    >
      {children}
    </LoadScript>
  );
};
